import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import HeaderTitle from '../components/HeaderTitle.jsx'
import Button from '../components/Button.jsx'
import sendContactMail from '../api/sendContactMail'
import setContactCategoryAction from '../actions/setContactCategory'

class ContactMailContainer extends Component {
    state = {
        isDropDownOpen: false,
        selectedDropdown: 0,
        contactMail: {},
        buttonLoading: false,
        buttonText: this.props.langData.btnText,
        buttonError: '',
        gdprCheckbox: false
    }

    componentDidMount() {
        if (this.props.match.params.id && this.props.match.params.id !== this.props.contactCategory) {
            const id = parseInt(this.props.match.params.id, 10)
            if (id < 3 && id >= 0) {
                this.props.setContactCategoryAction(id)
            }
        }
    }

    componentWillUnmount() {
        this.props.setContactCategoryAction(0)
    }

    openDropdown = () => {
        this.setState(prevState => ({
            isDropDownOpen: !prevState.isDropDownOpen
        }))
    }

    selectCategory = (key) => {
        this.props.setContactCategoryAction(key)
        this.setState({
            selectedDropdown: 0,
            isDropDownOpen: false
        })
        this.props.history.push(`/kontakt/${key}`)
    }

    selectDropdownItem = (key) => {
        this.setState({
            selectedDropdown: key
        })
        this.openDropdown()
    }

    handleCheckbox = () => {
        this.setState(prevState => ({
            gdprCheckbox: !prevState.gdprCheckbox
        }))
    }

    handleMailInput = (key, e) => {
        const newObject = Object.assign({}, this.state.contactMail)
        newObject[key] = e.target.value
        this.setState({
            contactMail: newObject
        })
    }

    sendMail = () => {
        this.setState({
            buttonLoading: true
        })
        const newObject = Object.assign({}, this.state.contactMail)
        const mailObject = {
            ...newObject,
            category: this.props.langData.categories[this.props.contactCategory],
            subCategory: this.props.langData.placehDropD[this.props.contactCategory][this.state.selectedDropdown]
        }
        if (mailObject.name && mailObject.email && this.state.selectedDropdown !== 0) {
            sendContactMail(mailObject)
                .then(() => {
                    setTimeout(() => {
                        this.setState({
                            buttonLoading: false,
                            buttonDisabled: true,
                            buttonText: this.props.langData.btnSentText,
                            buttonError: ''
                        })
                    }, 500)
                })
                .catch(() => {
                    this.setButtonError(0)
                })
        } else {
            this.setButtonError(1)
        }
    }

    setButtonError = (id) => {
        setTimeout(() => {
            this.setState({
                buttonError: this.props.langData.btnError[id],
                buttonLoading: false,
                buttonDisabled: false
            })
        }, 500)
    }

    render() {
        let spinner = null
        if (this.state.buttonLoading) {
            spinner = <div className="mk-spinner-ring-centered mk-spinner-ring-small"></div>
        }
        const categorieItems = this.props.langData.categories.map((val, key) => {
            let activeDotClass = ''
            let activeTextClass = ''
            if (this.props.contactCategory === key) {
                activeDotClass = 'input-categories__item-dot--active'
                activeTextClass = 'input-categories__item-text--active'
            }
            return (
                <div
                    className="input-categories__item"
                    key={key}
                    onClick={this.selectCategory.bind(null, key)}
                >
                    <div className={`input-categories__item-dot ${activeDotClass}`}></div>
                    <span className={`input-categories__item-text ${activeTextClass}`}>{val}</span>
                </div>
            )
        })

        const dropdownDataArr = []
        this.props.langData.placehDropD[this.props.contactCategory].forEach((val, i) => (
            dropdownDataArr.push({
                text: val,
                index: i
            })
        ))

        const dropdownItemsData = dropdownDataArr.filter(val => val.index !== 0)

        let dropdownItems = ''
        let arrowActiveClass = ''
        if (this.state.isDropDownOpen) {
            arrowActiveClass = 'input-dropdown__arrow--active'
            dropdownItems = dropdownItemsData.map((val, key) => (
                <div
                    className="input__item input-dropdown__item"
                    onClick={this.selectDropdownItem.bind(null, val.index, val.text)}
                    key={key}
                >
                    <span className="input-dropdown--text">
                        {val.text}
                    </span>
                </div>
            ))
        }

        const gdprClass = this.state.gdprCheckbox ? 'contact-checkbox--on' : ''
        const buttonClass = this.state.buttonLoading ? 'cbutton--yellowtext' : ''

        return (
            <div className="section-spacing section-spacing--first">
                <div className="container">
                    <div className="contact-container">
                        <HeaderTitle
                            className="header1--center"
                            title={this.props.langData.title}
                        />
                        <div className="input-categories">
                            {categorieItems}
                        </div>
                        <div className="row contact-input-row">
                            <div className="contact-input">
                                <div className="col-md-6">
                                    <div className="input-item-container">
                                        <input
                                            className="input__item"
                                            type="text"
                                            placeholder={`${this.props.langData.placehName}*`}
                                            onChange={this.handleMailInput.bind(null, 'name')}
                                        />
                                        <div className="input__item--border"></div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item-container">
                                        <input
                                            className="input__item"
                                            type="text"
                                            placeholder={this.props.langData.placehCompany}
                                            onChange={this.handleMailInput.bind(null, 'company')}
                                        />
                                        <div className="input__item--border"></div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item-container">
                                        <input
                                            className="input__item"
                                            type="email"
                                            placeholder={`${this.props.langData.placehEmail}*`}
                                            onChange={this.handleMailInput.bind(null, 'email')}
                                        />
                                        <div className="input__item--border"></div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item-container">
                                        <input
                                            className="input__item"
                                            type="text"
                                            placeholder={this.props.langData.placehPhone}
                                            onChange={this.handleMailInput.bind(null, 'phone')}
                                        />
                                        <div className="input__item--border"></div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="dropdown-container">
                                        <div
                                            className="input__item input-dropdown"
                                            onClick={this.openDropdown}
                                        >
                                            <span className="input-dropdown__text">
                                                {dropdownDataArr[this.state.selectedDropdown].text}
                                            </span>
                                            <img
                                                className={`input-dropdown__arrow ${arrowActiveClass}`}
                                                src="/images/ico/bed_drop.png"
                                            />
                                        </div>
                                        <div className="dropdown-items">
                                            {dropdownItems}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-item-container">
                                        <textarea
                                            className="input__item input__item--text"
                                            rows={3}
                                            placeholder={this.props.langData.placehMessage}
                                            onChange={this.handleMailInput.bind(null, 'message')}
                                        >
                                        </textarea>
                                        <div className="input__item--border"></div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div
                                        onClick={this.handleCheckbox}
                                        className="gdpr-container"
                                    >
                                        <div className={`contact-checkbox ${gdprClass}`}></div>
                                        <p className="contact-gdpr">{this.props.langData.gdpr}</p>
                                    </div>
                                    <div className="input-button">
                                        {spinner}
                                        <Button
                                            type="yellow"
                                            text={this.state.buttonText}
                                            onClick={this.sendMail}
                                            className={buttonClass}
                                            disabled={!this.state.gdprCheckbox || this.state.buttonDisabled}
                                        />
                                        <div className="input-button__error">
                                            {this.state.buttonError}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.contact,
    contactCategory: state.contactCategory
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setContactCategoryAction
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactMailContainer))



// WEBPACK FOOTER //
// ./src/scripts/containers/ContactMailContainer.jsx